import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-66e8c72a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "notification"
};
var _hoisted_2 = {
  class: "d-flex flex-row align-items-center"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "dot d-inline-block rounded-circle mx-2"
  }, null, -1);
});

var _hoisted_4 = /*#__PURE__*/_createTextVNode(" Group invitation ");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("View");

import { computed } from "vue";
import { DateTime } from "luxon";
import { UseTimeAgo } from "@vueuse/components";
import { silentRead } from "@/utils/notifications";
import { NotificationType } from "@/types/models/notification";
import NotificationContent from "@/components/notifications/NotificationContent.vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    notification: null
  },
  setup: function setup(__props) {
    var props = __props;
    var date = computed(function () {
      return DateTime.fromISO(props.notification.creationDate, {
        zone: "UTC"
      });
    });
    return function (_ctx, _cache) {
      var _component_n_text = _resolveComponent("n-text");

      var _component_n_button = _resolveComponent("n-button");

      var _component_router_link = _resolveComponent("router-link");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(NotificationContent, {
        notification: __props.notification,
        depth: 2
      }, null, 8, ["notification"]), _createElementVNode("div", null, [_createVNode(_unref(UseTimeAgo), {
        time: _unref(date).toJSDate()
      }, {
        default: _withCtx(function (_ref) {
          var timeAgo = _ref.timeAgo;
          return [_renderSlot(_ctx.$slots, "time", {
            time: timeAgo
          }, function () {
            return [_createVNode(_component_n_text, {
              depth: "3"
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("small", _hoisted_2, [_createTextVNode(_toDisplayString(timeAgo) + " ", 1), __props.notification.type === _unref(NotificationType).GroupInvite ? (_openBlock(), _createElementBlock(_Fragment, {
                  key: 0
                }, [_hoisted_3, _hoisted_4], 64)) : _createCommentVNode("", true)])];
              }),
              _: 2
            }, 1024)];
          })];
        }),
        _: 3
      }, 8, ["time"])]), __props.notification.type === _unref(NotificationType).GroupInvite ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: {
          name: 'Invitation',
          params: {
            token: __props.notification.payload.token
          }
        },
        class: "text-decoration-none"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_button, {
            secondary: "",
            type: "info",
            size: "small",
            class: "mt-3 px-3",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return _unref(silentRead)([__props.notification.userNotificationId]);
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_5];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["to"])) : _createCommentVNode("", true)]);
    };
  }
});